<template>
  <div class="d-searchProPriority">
    <DSwitch
      v-model="innerValue"
      true-value="1"
      false-value="0"
      is-animation-waiting
    >
      <span class="d-searchProPriority_label">
        PRO認定を優先表示<ProIcon
          class="d-searchProPriority_proIcon"
          is-question />
      </span>
    </DSwitch>
  </div>
</template>
<script>
import DSwitch from '~/components/atoms/DS2/DSwitch'
import ProIcon from '~/components/molecules/ProIcon'
export default {
  name: 'SearchProPriority',
  components: { DSwitch, ProIcon },
  props: {
    value: {
      type: String,
      required: true
    }
  },
  computed: {
    innerValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>
<style lang="scss">
.d-searchProPriority {
  display: flex;
  color: $ds2-color-gray-900;
  letter-spacing: 0.05em;
  font-size: 13px;
  &_label {
    display: flex;
    margin-top: 1px;
    line-height: 14px;
  }
  &_proIcon {
    margin-left: 4px;
    // safari対応
    height: 13px;
    color: $ds2-color-gray-400;
    word-break: break-all;
  }
}
</style>
